import * as React from 'react'
import { Globe } from 'react-feather'

import { CaretDownIcon, CaretUpIcon, palette, spacing } from 'main/ui'

import { CaretIconContainer, Container, StyledSelect, StyledText } from './Select.styles'

interface IProps {
  children: React.ReactNode
  value: string | null
  onChange: (value: string | null) => void
}

const Select = (props: IProps) => {
  const { children, value, onChange } = props
  const [focused, setFocused] = React.useState(false)

  return (
    <>
      <Container>
        <Globe size={spacing.majorScale(3)} color={palette.mediumGray} />
        <StyledText>
          <StyledSelect
            value={value === null ? '' : value}
            onBlur={handleBlur}
            onChange={handleChange}
            onFocus={handleFocus}
          >
            {children}
          </StyledSelect>
        </StyledText>
        <CaretIconContainer>{focused ? <CaretUpIcon /> : <CaretDownIcon />}</CaretIconContainer>
      </Container>
    </>
  )

  function handleBlur() {
    setFocused(false)
  }

  function handleFocus() {
    setFocused(true)
  }

  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    onChange(event.target.value === '' ? null : event.target.value)
    setFocused(false)
  }
}

export default React.memo(Select)
